var exports = {
  "mg": "SparkleCharacter__RYxi_0",
  "bh": "SparkleCharacterAnimated__9C4_N7",
};

module.exports = exports;
